module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/spoon-f2428c7c957030ccc3464ce124ccae6c.svg";